import { Col, Modal, Row, Switch, Tooltip, notification } from 'antd';
import styles from './index.module.sass';
import { InputWithSign } from '@/modules/common/components/input-with-sign';
import { ButtonPrimary } from '@/shared/ui/button';
import { CalendarPicker } from '../calendar-picker';
import { useEffect, useRef, useState } from 'react';
import {
  IInitialFormState,
  useAddOfferFormState,
} from '../../../seller-account/hooks/use-add-offer.hook';
import {
  $offerToEdit,
  setOfferToEdit,
} from '../../../seller-account/store/offers.store';
import { useStore } from 'effector-react';
import { $singleBuyerData } from '../../../seller-account/store/buyers.store';
import { InputSignWrap } from '@/modules/common/components/input-sign-wrap';
import { SelectUniversal } from '@/modules/common/components/select-universal';
import { SortPicker } from './components/sort-picker';
import {
  wheatClasses,
  wheatSorts,
  wheatTypes,
} from '../../constants/wheat-types.constatnt';
import { handleCreate } from './functions/handle-create.helper';
import { handleUpdate } from './functions/handle-update.helper';
import { setOfferState } from './functions/load-for-edit.helper';
import { indicateWheatType } from '../../helpers/wheat-type.helper';
import { DiContainer } from '@/modules/di/di-container';
import { BagsService } from '@/modules/bags/services/bags.service';
import { InputWithSignWheelControl } from '../input-with-sign-wheel';
import infoSvg from '@@/mixing/images/info-icon.svg';
import { ICreateBuyerOfferArgs } from '@/modules/buyer-account/functions/create-buyer-offer.function';
import { IUpdateBuyerPointArgs } from '@/modules/buyer-account/functions/update-buyer-offer.function';
import { BuyerInstance } from '@/modules/seller-account/ts';
import { $agriculture } from '@/modules/agriculture/store/agriculture.store';
import { debounce } from 'lodash-es';
import { PURCHASE_PRICE_WITHOUT_VAT } from '@/shared/constants/price.constants';
const bagsService = DiContainer.get(BagsService);

export const AddOfferModal = ({
  visible,
  closeFn,
  header,
  customCreateFoo,
  customUpdateFoo,
  refetchBuyersList,
}: IAddOfferModal) => {
  // GLOBAL STATES
  const offerToEdit = useStore($offerToEdit);
  const buyerInfo = useStore($singleBuyerData);
  const agriculture = useStore($agriculture);
  const wheatData = agriculture.find((item) => item.id === 1);
  const fieldsParams = {
    protein: wheatData?.parameters.find((item) => item.id === 5) || undefined,
    humidity: wheatData?.parameters.find((item) => item.id === 2) || undefined,
    cp: wheatData?.parameters.find((item) => item.id === 4) || undefined,
    idk: wheatData?.parameters.find((item) => item.id === 3) || undefined,
    gluten: wheatData?.parameters.find((item) => item.id === 1) || undefined,
    nature: wheatData?.parameters.find((item) => item.id === 6) || undefined,
  };

  // LOCAL STATES
  const { formState, handleChange, resetForm, setFormState } = useAddOfferFormState();
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [indicatedClass, setIndicatedClass] = useState(-1);
  const [date, setDate] = useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate() + 1, // по умолчанию для оффера на сутки вперед
    hours: new Date().getHours(),
    minutes: new Date().getMinutes(),
  });

  // CLICK OUTSIDE
  const elemRef = useRef<any>(null);
  const handleClickOutside = (event: any) => {
    if (elemRef.current && !elemRef.current.contains(event.target)) {
      visible ? setShowDatePicker(false) : null;
    }
  };

  const debouncedClassIndication = debounce(async () => {
    try {
      const res: any = await bagsService.getWheatClass({
        wheat_type: formState.wheatType?.toString(),
        protein: formState.protein,
        gluten: formState.gluten,
        idk: formState.idk,
        hfn: formState.cp,
        density: formState.nature,
        moisture: formState.humidity,
        weed: formState.weed,
      });
      setIndicatedClass(res.wheat_class);
      handleChange('wheatClass', res.wheat_class);
    } catch (err) {
      return notification.error({
        message:
          'Ошибка автоматического определения класса зерна. Попробуйте, пожалуйста, позже.',
      });
    }
  }, 150);

  // EFFECTS
  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setShowDatePicker(false);
    return () => {
      resetForm();
      setOfferToEdit(null);
    };
  }, []);

  useEffect(() => {
    !isNaN(date.day)
      ? handleChange(
          'expiryDate',
          `${date.day > 9 ? date.day : '0' + date.day}.${
            date.month > 9 ? date.month : '0' + date.month
          }.${date.year} ${date.hours > 9 ? date.hours : '0' + date.hours}:${
            date.minutes > 9 ? date.minutes : '0' + date.minutes
          }:00`,
        )
      : handleChange('expiryDate', '');
  }, [date]);

  useEffect(() => {
    if (
      formState.wheatType &&
      formState.protein &&
      formState.gluten &&
      formState.idk &&
      formState.cp &&
      formState.nature &&
      formState.humidity &&
      formState.weed
    ) {
      (async () => {
        try {
          const res: any = await bagsService.getWheatClass({
            wheat_type: formState.wheatType?.toString(),
            protein: formState.protein,
            gluten: formState.gluten,
            idk: formState.idk,
            hfn: formState.cp,
            density: formState.nature,
            moisture: formState.humidity,
            weed: formState.weed,
          });
          setIndicatedClass(res.wheat_class);
          //handleChange('wheatClass', res.wheat_class);
        } catch (err) {
          return notification.error({
            message:
              'Ошибка автоматического определения класса зерна. Попробуйте, пожалуйста, позже.',
          });
        }
      })();
      //debouncedClassIndication();
    }
  }, [
    formState.wheatType,
    formState.protein,
    formState.gluten,
    formState.idk,
    formState.cp,
    formState.nature,
    formState.humidity,
    formState.weed,
  ]);

  useEffect(() => {
    if (formState.sort && formState.type) {
      handleChange(
        'wheatType',
        Number(indicateWheatType(String(formState.sort), String(formState.type))),
      );
    }
  }, [formState.sort, formState.type]);

  // on load offer to edit
  useEffect(() => {
    if (offerToEdit) {
      setOfferState({ offerToEdit, setFormState, setDate, resetForm, formState });

      if (offerToEdit.expiration_offer) {
        // const utcDate = new Date(offerToEdit.expiration_offer);
        // const localOffsetMinutes = utcDate.getTimezoneOffset();
        //const expirationDate = new Date(utcDate.setMinutes(utcDate.getMinutes() - localOffsetMinutes));
        const expirationDate = new Date(offerToEdit.expiration_offer);
        setDate({
          year: expirationDate.getFullYear(),
          month: expirationDate.getMonth() + 1,
          day: expirationDate.getDate(),
          hours: expirationDate.getHours(),
          minutes: expirationDate.getMinutes(),
        });
      }
    }
  }, [offerToEdit]);

  const setWheatClassFormOrigin = async (
    formState: IInitialFormState,
    classNumber: number,
  ) => {
    if (!formState.sort || !formState.type) {
      return notification.warning({ message: 'Необходимо указать сорт и тип пшеницы' });
    } else {
      const res: any = await bagsService.getClassParams(
        classNumber,
        Number(indicateWheatType(formState.sort, formState.type)),
      );

      return Modal.confirm({
        title: 'Подтвердите действие',
        content:
          'Данное действие переустановит параметры зерна, на соответсвующие для выбранного класа, Вы уверены что хотите продолжить?',
        okText: 'да',
        cancelText: 'нет',
        onOk: () => {
          setFormState({
            ...formState,
            protein: String(res?.protein || '0'),
            gluten: String(res?.gluten || '0'),
            idk: String(res?.idk || '0'),
            cp: String(res?.hfn || '0'),
            nature: String(res?.density || '0'),
            clop: String(res?.byg ?? '0'),
            humidity: String(res?.moisture || '0'),
            wheatClass: res?.wheat_class || '0',
            weed: '0',
            admixtureOtherCereals: '0',
            wheatDifferentType: '0',
          });
        },
      });
    }
  };

  return (
    <Modal
      className={styles.root}
      width={898}
      title={
        header || offerToEdit ? 'редактирование предложения' : 'добавление предложения'
      }
      open={visible}
      onCancel={closeFn}
      footer={[]}
    >
      <div className={styles.root}>
        <Row
          gutter={8}
          style={{
            marginBottom: 16,
          }}
        >
          <Col span={12}>
            <InputSignWrap label="сорт пшеницы*">
              <SelectUniversal
                activeItem={
                  formState.sort &&
                  wheatSorts.find((item) => item.value === formState.sort)
                }
                onChange={(value: string) => {
                  handleChange('sort', value);
                  // handleChange(
                  //   'wheatType',
                  //   Number(indicateWheatType(value, String(formState.type))),
                  // );
                }}
                options={wheatSorts}
                placeholder="сорт не выбран"
              />
            </InputSignWrap>
          </Col>
          <Col span={12}>
            <InputSignWrap label="тип пшеницы*">
              <SelectUniversal
                activeItem={
                  formState.type &&
                  wheatTypes.find((item) => item.value === formState.type)
                }
                onChange={(value: string) => {
                  handleChange('type', value);
                  // handleChange(
                  //   'wheatType',
                  //   Number(indicateWheatType(String(formState.sort), value)),
                  // );
                }}
                options={wheatTypes}
                placeholder="тип не указан"
              />
            </InputSignWrap>
          </Col>
        </Row>
        <Row gutter={8} style={{ marginBottom: 16 }}>
          <SortPicker
            options={wheatClasses}
            selectedId={
              indicatedClass !== -1 ? indicatedClass : Number(formState.wheatClass)
            }
            onClick={(id) => setWheatClassFormOrigin(formState, Number(id))}
          />
        </Row>
        <Row
          gutter={8}
          style={{
            marginBottom: 16,
            borderBottom: '2px solid #EEF2FD',
            paddingBottom: 16,
          }}
        >
          <Col span={6}>
            <InputWithSignWheelControl
              value={formState.year ?? ''}
              onChange={(e) =>
                handleChange(
                  'year',
                  e.target.value > new Date().getFullYear()
                    ? new Date().getFullYear()
                    : e.target.value,
                  'number',
                )
              }
              setValue={(val) =>
                handleChange(
                  'year',
                  Number(val) > new Date().getFullYear()
                    ? new Date().getFullYear()
                    : val,
                  'number',
                )
              }
              postfix={''}
              label="год урожая*"
              float={false}
              placeholder={new Date().getFullYear().toString()}
              max={new Date().getFullYear()}
            />
          </Col>
          <Col span={6}>
            <InputWithSignWheelControl
              prefix="≥"
              placeholder=""
              value={formState.gluten ?? ''}
              label="клейковина*"
              onChange={(e) => handleChange('gluten', e.target.value, 'float')}
              setValue={(val) =>
                handleChange('gluten', parseFloat(String(val)), 'float')
              }
              min={fieldsParams.gluten?.options.min}
              max={fieldsParams.gluten?.options.max}
              float={true}
              postfix="%"
            />
          </Col>
          <Col span={6}>
            <InputWithSignWheelControl
              prefix="≤"
              value={formState.idk ?? ''}
              placeholder=""
              label="ИДК*"
              onChange={(e) => handleChange('idk', e.target.value, 'number')}
              setValue={(val) => handleChange('idk', parseFloat(String(val)), 'number')}
              min={fieldsParams.idk?.options.min}
              max={fieldsParams.idk?.options.max}
              postfix=""
            />
          </Col>
          <Col span={6}>
            <InputWithSignWheelControl
              prefix="≥"
              placeholder=""
              value={formState.clop ?? ''}
              label="клоп*"
              onChange={(e) => handleChange('clop', e.target.value, 'number')}
              setValue={(val) => handleChange('clop', val, 'number')}
              postfix="%"
            />
          </Col>
          <Col span={6} className={styles.input_padding}>
            <InputWithSignWheelControl
              prefix="≥"
              placeholder=""
              value={formState.protein ?? ''}
              label="протеин*"
              onChange={(e) => handleChange('protein', e.target.value, 'float')}
              setValue={(val) => handleChange('protein', val, 'float')}
              min={fieldsParams.protein?.options.min}
              max={fieldsParams.protein?.options.max}
              postfix="%"
              float={true}
            />
          </Col>
          <Col span={6} className={styles.input_padding}>
            <InputWithSignWheelControl
              prefix="≥"
              placeholder=""
              value={formState.cp ?? ''}
              label="ЧП*"
              onChange={(e) => handleChange('cp', e.target.value, 'number')}
              setValue={(val) => handleChange('cp', val, 'number')}
              min={fieldsParams.cp?.options.min}
              max={fieldsParams.cp?.options.max}
              postfix="сек"
            />
          </Col>
          <Col span={6} className={styles.input_padding}>
            <InputWithSignWheelControl
              prefix="≥"
              placeholder=""
              value={formState.nature ?? ''}
              label="натура*"
              onChange={(e) => handleChange('nature', e.target.value, 'number')}
              setValue={(val) => handleChange('nature', val, 'number')}
              min={fieldsParams.nature?.options.min}
              max={fieldsParams.nature?.options.max}
              postfix="г/л"
            />
          </Col>
          <Col span={6} className={styles.input_padding}>
            <InputWithSignWheelControl
              prefix="≤"
              placeholder=""
              value={formState.humidity ?? ''}
              label="влажность*"
              onChange={(e) => handleChange('humidity', e.target.value, 'number')}
              setValue={(val) => handleChange('humidity', val, 'number')}
              min={fieldsParams.humidity?.options.min}
              max={fieldsParams.humidity?.options.max}
              postfix="%"
            />
          </Col>
        </Row>
        <Row
          gutter={8}
          style={{
            marginBottom: 16,
            borderBottom: '2px solid #EEF2FD',
            paddingBottom: 16,
          }}
        >
          <Col span={8}>
            <InputWithSignWheelControl
              prefix="≤"
              placeholder=""
              value={formState.weed ?? ''}
              label="сорная примесь"
              onChange={(e) => handleChange('weed', e.target.value, 'number')}
              setValue={(val) => handleChange('weed', val, 'number')}
              postfix=""
              autogrow={true}
            />
          </Col>
          <Col span={8}>
            <InputWithSignWheelControl
              prefix="≤"
              placeholder=""
              value={formState.admixtureOtherCereals ?? ''}
              label="примесь других злаковых культур"
              onChange={(e) =>
                handleChange('admixtureOtherCereals', e.target.value, 'number')
              }
              setValue={(val) => handleChange('admixtureOtherCereals', val, 'number')}
              postfix=""
            />
          </Col>
          <Col span={8}>
            <InputWithSignWheelControl
              prefix="≤"
              placeholder=""
              value={formState.wheatDifferentType ?? ''}
              label="пшеница другого типа"
              onChange={(e) =>
                handleChange('wheatDifferentType', e.target.value, 'number')
              }
              setValue={(val) => handleChange('wheatDifferentType', val, 'number')}
              postfix=""
              autogrow={true}
            />
          </Col>
          <Col className={styles.pickup} span={24}>
            <>
              <span className={styles.mixerTitle}>доп.опции</span>
              <div
                className={styles.mixer}
                onClick={() => handleChange('pickup', !formState.pickup)}
              >
                <span>
                  <Tooltip title="стоимость логистики включена в стоимость предложения">
                    <img className={styles.info} src={infoSvg} />
                  </Tooltip>{' '}
                  самовывоз покупателем со склада продавца:{' '}
                </span>
                <Switch checked={formState.pickup} />
              </div>
            </>
          </Col>
        </Row>
        <Row gutter={8} style={{ marginBottom: 16 }}>
          <Col span={12}>
            <div className={styles.dateBlock} ref={elemRef}>
              <InputWithSign
                autogrow={true}
                onClick={() => setShowDatePicker(!showDatePicker)}
                value={formState.expiryDate}
                label="срок действия предложения* "
                onChange={() => {}}
                postfix=""
                mask={[
                  /\d/,
                  /\d/,
                  '.',
                  /\d/,
                  /\d/,
                  '.',
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                  ' ',
                  /\d/,
                  /\d/,
                  ':',
                  /\d/,
                  /\d/,
                ]}
                placeholder={`${date.day > 9 ? date.day : '0' + date.day}.${
                  date.month > 9 ? date.month : '0' + date.month
                }.${date.year} ${date.hours > 9 ? date.hours : '0' + date.hours}:${
                  date.minutes > 9 ? date.minutes : '0' + date.minutes
                }`}
              />
              <CalendarPicker
                date={date}
                setDate={setDate}
                visible={showDatePicker}
                closeFn={() => setShowDatePicker(false)}
                allowPastDate={false}
              />
            </div>
          </Col>
          <Col span={12}>
            <InputWithSignWheelControl
              value={formState.buyingPrice}
              label={`${PURCHASE_PRICE_WITHOUT_VAT}*`}
              onChange={(e) => handleChange('buyingPrice', e.target.value, 'number')}
              setValue={(val) => handleChange('buyingPrice', val, 'number')}
              postfix="₽/т"
              autogrow={true}
            />
          </Col>
        </Row>

        <Row
          gutter={8}
          style={{
            marginBottom: 16,
            borderTop: '2px solid #EEF2FD',
            paddingTop: 16,
          }}
        >
          <span className={styles.label_explanation}>* обязательные параметры</span>
        </Row>
        <div className={styles.actions}>
          <ButtonPrimary
            label={'сохранить'}
            className={styles.button}
            onClick={async () => {
              let errors = 0;
              if (
                isNaN(Number(formState.wheatClass)) ||
                Number(formState.wheatClass) <= 0
              ) {
                errors++;
                notification.error({
                  message:
                    'Ошибка сервера: Не удалось определить класс. Попробуйте, пожалуйста, позже',
                });
              }

              if (!formState.wheatType) {
                errors++;
                notification.warning({
                  message: 'Укажите тип и/или сорт пшеницы',
                });
              }

              if (!formState.expiryDate) {
                errors++;
                notification.warning({
                  message: 'Укажите срок действия предложения',
                });
              }

              if (isNaN(+formState.gluten) || +formState.gluten <= 0) {
                errors++;

                notification.warning({
                  message: 'Укажите значение для поля "клейковина"',
                });
              }

              if (isNaN(+formState.idk) || +formState.idk <= 0) {
                errors++;
                notification.warning({ message: 'Укажите значение для поля "ИДК"' });
              }

              if (isNaN(+formState.humidity) || +formState.humidity <= 0) {
                errors++;
                notification.warning({
                  message: 'Укажите значение для поля "влажность культуры"',
                });
              }

              if (isNaN(+formState.cp) || +formState.cp <= 0) {
                errors++;
                notification.warning({
                  message: 'Укажите значение для поля "число падения"',
                });
              }

              if (isNaN(+formState.protein) || +formState.protein <= 0) {
                errors++;
                notification.warning({
                  message: 'Укажите значение для поля "протеин"',
                });
              }

              if (isNaN(+formState.nature) || +formState.nature <= 0) {
                errors++;
                notification.warning({ message: 'Укажите значение для поля "натура"' });
              }

              if (!formState.buyingPrice || +formState.buyingPrice === 0) {
                errors++;
                return notification.warning({
                  message: 'Укажите стоимость предложения',
                  // message: 'Ошибка при сохранении',
                });
              }
              if (errors >= 1) return;

              if (offerToEdit) {
                customUpdateFoo
                  ? await customUpdateFoo({
                      date,
                      closeFn,
                      formState,
                      buyerInfo,
                      offerToEdit,
                      setOfferToEdit,
                      indicatedClass,
                    })
                  : await handleUpdate({
                      date,
                      closeFn,
                      formState,
                      buyerInfo,
                      offerToEdit,
                      setOfferToEdit,
                      refetchBuyersList,
                      indicatedClass,
                    });
              } else {
                customCreateFoo
                  ? await customCreateFoo({ date, closeFn, formState, buyerInfo })
                  : await handleCreate({
                      date,
                      closeFn,
                      formState,
                      buyerInfo,
                      refetchBuyersList,
                    });
              }
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

interface IAddOfferModal {
  visible: boolean;
  closeFn: () => void;
  header?: string;
  customCreateFoo?: (data: ICreateBuyerOfferArgs) => Promise<void>;
  customUpdateFoo?: (data: IUpdateBuyerPointArgs) => Promise<void>;
  refetchBuyersList?: () => Promise<BuyerInstance[] | undefined>;
}
